import { render, staticRenderFns } from "./TaskPanel.vue?vue&type=template&id=5c16a066&scoped=true&"
import script from "./TaskPanel.vue?vue&type=script&lang=js&"
export * from "./TaskPanel.vue?vue&type=script&lang=js&"
import style0 from "./TaskPanel.vue?vue&type=style&index=0&id=5c16a066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16a066",
  null
  
)

export default component.exports